import { cwTodayISO } from './format';

export function isArrivingToday(b) {
  return b.Status === 'Confirmed' && b.CheckIn === cwTodayISO() && !b.CheckedInAt;
}
export function isInHouse(b) {
  return !!b.CheckedInAt && b.CheckOut > cwTodayISO();
}
export function isDepartingToday(b) {
  return b.CheckOut === cwTodayISO() && !!b.CheckedInAt;
}
export function isProofWaiting(b) {
  return b.PaymentStatus !== 'Complete' && b.Status === 'Held';
}
export function isHeld(b) { return b.Status === 'Held'; }
